// src/lib/sentry.js
// Gated Sentry initialization for the React/Vite frontend. Entirely controlled
// by VITE_SENTRY_DSN — when unset, initSentry() does nothing and captureApiError
// is a no-op, so builds without a DSN ship zero Sentry behavior.

import * as Sentry from '@sentry/react'

const DSN = import.meta.env.VITE_SENTRY_DSN
export const sentryEnabled = Boolean(DSN)

export function initSentry() {
  if (!sentryEnabled) return
  Sentry.init({
    dsn: DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE || undefined,
    tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || 0),
    // Don't attach default PII (IP address, etc.).
    sendDefaultPii: false,
  })
  // eslint-disable-next-line no-console
  console.log('[sentry] frontend error tracking enabled')
}

// Report an axios error to Sentry, but only for genuine server faults or
// network failures — never for expected 4xx (auth, validation, not-found),
// which are normal app flow and would just be noise.
export function captureApiError(error) {
  if (!sentryEnabled) return
  const status = error?.response?.status
  // No response → network/CORS/timeout failure worth tracking.
  // Response present → only 5xx are server faults.
  if (status && status < 500) return
  Sentry.captureException(error, {
    tags: { source: 'api' },
    extra: {
      url: error?.config?.url,
      method: error?.config?.method,
      status: status ?? 'no-response',
    },
  })
}

export { Sentry }
